// Package imports
import { createSlice } from "@reduxjs/toolkit";

// Custom imports
import findIndex from "lodash/findIndex";

// Initial State
const initialState = {
  currentAudioSrc: null,
  audioPlaying: false,
  videoPlaying: false,
  audioFinished: false,
  videoFinished: false
};

// Redux Slice for AudioVideo
const audioVideoSlice = createSlice({
  name: "audioVideo",
  initialState,
  reducers: {
    resetState(state, { payload }) {
      return initialState;
    },
    setCurrentAudioSrc(state, { payload }) {
        return {
          ...state,
          currentAudioSrc: payload,
        };
      },
    setAudioIsPlaying(state, { payload }) {
      return {
        ...state,
        audioPlaying: payload,
      };
    },
    setVideoIsPlaying(state, { payload }) {
        return {
          ...state,
          videoPlaying: payload,
        };
      },
      setAudioIsFinished(state, { payload }) {
        return {
          ...state,
          audioFinished: payload,
        };
      },
      setVideoIsFinished(state, { payload }) {
        return {
          ...state,
          videoFinished: payload,
        };
      },
  },
});

export const audioVideoSliceActions = audioVideoSlice.actions;

export default audioVideoSlice;
